import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "../config/env";

function getOrCreateCartId() {
  let id = localStorage.getItem("debsun-cart-id");
  if (!id) {
    id = window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : `cart-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("debsun-cart-id", id);
  }
  return id;
}

const cartId = getOrCreateCartId();
axios.defaults.headers.common["X-Cart-Id"] = cartId;

const EMPTY_CART = { cart_id: cartId, items: [], item_count: 0, subtotal: 0, currency: "INR" };

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(EMPTY_CART);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/cart`);
      setCart(data);
    } catch {
      /* ignore — cart stays as-is */
    }
  }, []);

  useEffect(() => {
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const addItem = async (productId, quantity = 1) => {
    const { data } = await axios.post(`${API}/cart/items`, { product_id: productId, quantity });
    setCart(data);
    return data;
  };

  const updateQuantity = async (productId, quantity) => {
    const { data } = await axios.put(`${API}/cart/items/${productId}`, { quantity });
    setCart(data);
    return data;
  };

  const removeItem = async (productId) => {
    const { data } = await axios.delete(`${API}/cart/items/${productId}`);
    setCart(data);
    return data;
  };

  const clearCart = async () => {
    const { data } = await axios.delete(`${API}/cart`);
    setCart(data);
    return data;
  };

  return (
    <CartContext.Provider value={{ cart, loading, cartId, refresh, addItem, updateQuantity, removeItem, clearCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
